import { snakelize, camelize } from '../../../helpers/object';

export default ($axios: any) => ({
  // 피드백 작성
  async submit(params: { brandToken: string; postingId: number; msg: string; temporaryKey?: string }) {
    return camelize(await $axios.post(`/inspection/${params.postingId}/feedback/submit`, snakelize(params)));
  },

  // 피드백 수정
  async store(params: { brandToken: string; postingId: number; msg: string; temporaryKey?: string }) {
    return camelize(await $axios.put(`/inspection/${params.postingId}/feedback/save`, snakelize(params)));
  },

  // 이미지 업로드 (expects FormData)
  async uploadImage(formData: FormData) {
    return camelize(
      await $axios.post(`/inspection/image/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    );
  },
});
